import { AlertCircle, Camera } from "lucide-react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { ambienteMeta } from "./ambientes";

interface Props {
  open: boolean;
  onClose: () => void;
  missingAmbientes: string[];
}

export function ChaoReportCloseRuleModal({ open, onClose, missingAmbientes }: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Não é possível enviar o registro"
      size="md"
      elevated
      footer={
        <div className="flex justify-end">
          <Button variant="primary" onClick={onClose}>
            Entendi
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 -mt-1">
        <div className="flex gap-3 rounded-xl border border-amber-200 bg-amber-50/90 px-4 py-3 text-amber-950">
          <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
          <p className="text-sm leading-relaxed">
            Para enviar o registro para aprovação, é obrigatório enviar{" "}
            <strong>pelo menos uma foto em cada ambiente</strong> da unidade. Assim o relatório fica completo para
            o administrador avaliar.
          </p>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">
            Ambientes sem foto ({missingAmbientes.length})
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-[min(50vh,280px)] overflow-y-auto pr-1">
            {missingAmbientes.map((key) => {
              const meta = ambienteMeta(key);
              const Icon = meta.icon;
              return (
                <li
                  key={key}
                  className="flex items-center gap-2.5 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5"
                >
                  <span
                    className={`w-8 h-8 rounded-lg flex items-center justify-center text-white flex-shrink-0 ${meta.bar}`}
                  >
                    <Icon className="w-4 h-4" />
                  </span>
                  <span className="text-sm font-semibold text-slate-800">{meta.label}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <p className="text-xs text-slate-500 flex items-start gap-2">
          <Camera className="w-4 h-4 flex-shrink-0 mt-0.5" />
          Registre as fotos faltantes na seção &quot;Fotos por ambiente&quot; e tente enviar novamente.
        </p>
      </div>
    </Modal>
  );
}
